import React from 'react'
import { Link } from 'react-router-dom'

function Offer() {
  return (
    <div>
      <div className="container-fluid bg-offer my-5 py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-7 wow zoomIn" data-wow-delay="0.6s">
            <div className="offer-text text-center rounded p-5">
              <h1 className="display-5 text-white">Offer 10% On Your First Time To Book Senator Hotel</h1>
              <Link to="/appointment" className="btn btn-dark py-3 px-5 me-3">Book Now</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Offer
